import { Box, Flex, Icon, Text, Tooltip } from "monday-ui-react-core";
import { Info } from "monday-ui-react-core/icons";

import { CliDownloadPanel } from "@/components/CallToAction";
import { CliRunner } from "@/components/CliRunner";
import { ShortLink } from "@/components/Common";

interface Props {
  editableCommand: string;
}

export function RunPanel({ editableCommand }: Props) {
  return (
    <Flex align={Flex.align.START} justify={Flex.justify.SPACE_BETWEEN} gap={Flex.gaps.LARGE}>
      <div style={{ marginBottom: "var(--spacing-large)", width: "70%" }}>
        <Box>
          <Text type={Text.types.TEXT2} ellipsis={false}>
            CLI - Automate Actions uses simple, text-based commands to convert lengthy manual tasks to powerful,
            automated actions. Explore the <ShortLink path="monday_getstarted">documentation</ShortLink> for tips on
            creating the commands.
          </Text>
        </Box>
        <Flex justify={Flex.justify.END}>
          <Tooltip content="This input is used to execute commands and perform automated actions. Try copying a command from the examples tab (above) and pasting it in the box. Then push the Run button and watch as the action gets performed!">
            <Icon icon={Info} />
          </Tooltip>
        </Flex>
        <CliRunner initialCommand={editableCommand} />
      </div>
      <div style={{ width: "30%" }}>
        <CliDownloadPanel />
      </div>
    </Flex>
  );
}
